module.exports = __webpack_public_path__ + "img/total.c4eb006e.svg";